import "../App.css";
import React from "react";

export function LoadingPage() {
  /* 장애일 때 렌더링 할 부분 */
  let loadingPage = <h1> 로딩중입니다 잠시만.. </h1>;
  let content = loadingPage;

  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export default LoadingPage;
